import { NATIVE_ADDRESS, NATIVE_SOL, ZERO_ADDRESS } from '../config/networks';
/**
 * Determines if a given token address is a native token.
 *
 * @param tokenAddress - The address of the token.
 * @param isEVM - A boolean indicating if the environment is EVM. Default is true.
 * @returns A boolean indicating if the token is a native token.
 */
export function isNativeToken(tokenAddress, isEVM) {
    if (isEVM === void 0) { isEVM = true; }
    return isEVM
        ? tokenAddress.toLowerCase() === NATIVE_ADDRESS.toLowerCase() ||
            tokenAddress.toLowerCase() === ZERO_ADDRESS.toLowerCase()
        : tokenAddress.toLowerCase() == NATIVE_SOL;
}
